import React from 'react';
import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';
import messages from '../CalendarLinks.messages';

const { element } = bem('icalendar-flow');

const IcalExportModal = ({ exportUrl }) => (
  <Confirm
    title={<Message message={messages.exportUrlModalTitle} />}
    cancelNode={<Message message={messages.exportUrlModalCancel} />}
    acceptNode={<Message message={messages.exportUrlModalCopy} />}>
    <Message message={messages.exportUrlModalBody} />
    <div className={element('ical-export-url')}>{exportUrl}</div>
  </Confirm>
);

export default IcalExportModal;

IcalExportModal.propTypes = {
  exportUrl: PropTypes.string.isRequired,
};
